import { render, staticRenderFns } from "./dialog_giftbag.vue?vue&type=template&id=9935f7c0&scoped=true&"
import script from "./dialog_giftbag.vue?vue&type=script&lang=js&"
export * from "./dialog_giftbag.vue?vue&type=script&lang=js&"
import style0 from "./dialog_giftbag.vue?vue&type=style&index=0&id=9935f7c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9935f7c0",
  null
  
)

export default component.exports